import styled from "styled-components";
import {
  textGradientBlue,
  textGradientMagenta,
} from "../../../components/Typography";

export const GradientText1 = styled.span`
  ${textGradientBlue};
  display: inline-block;
`;

export const GradientText2 = styled.span`
  ${textGradientMagenta};
  display: inline-block;
`;

export const mediaCreators = [
  ["content", "creators"],
  ["music", "artists"],
  ["stories", "writers"],
  ["moments", "athletes"],
] as const;
